/** Controls for both players, merged from the keyboard and the pads, one `Command` pair per frame. */

import type { Command } from '../sim/types';
import { padCommand } from './gamepad';
import { type KeyBindings, Keyboard } from './keyboard';

export { Keyboard } from './keyboard';
export type { KeyBindings } from './keyboard';

const merge = (a: Command, b: Command | null): Command => (b
  ? { left: a.left || b.left, right: a.right || b.right, jump: a.jump || b.jump, fire: a.fire || b.fire }
  : a);

export function readCommands(keys: Keyboard, bindings: readonly [KeyBindings, KeyBindings]): [Command, Command] {
  const fromKeys = (i: 0 | 1): Command => {
    const k = bindings[i];
    return { left: keys.held(k.left), right: keys.held(k.right), jump: keys.held(k.jump), fire: keys.held(k.fire) };
  };
  return [merge(fromKeys(0), padCommand(0)), merge(fromKeys(1), padCommand(1))];
}
